"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Textarea = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _styledComponents = require("styled-components");
var _oxygenConfig = require("@8x8/oxygen-config");
var _TextareaWrapper = _interopRequireDefault(require("../styled/TextareaWrapper"));
var _themeName = _interopRequireDefault(require("../constants/themeName"));
var _excluded = ["theme", "id", "forwardedRef", "name", "autoComplete", "autoFocus", "placeholder", "value", "rows", "cols", "minLength", "maxLength", "resize", "testId", "isDisabled", "isReadOnly", "hasError", "onBlur", "onChange", "onFocus", "onKeyUp", "onKeyDown"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Textarea = function Textarea(_ref) {
  var theme = _ref.theme,
    id = _ref.id,
    forwardedRef = _ref.forwardedRef,
    name = _ref.name,
    autoComplete = _ref.autoComplete,
    autoFocus = _ref.autoFocus,
    placeholder = _ref.placeholder,
    value = _ref.value,
    rows = _ref.rows,
    cols = _ref.cols,
    minLength = _ref.minLength,
    maxLength = _ref.maxLength,
    resize = _ref.resize,
    testId = _ref.testId,
    isDisabled = _ref.isDisabled,
    isReadOnly = _ref.isReadOnly,
    hasError = _ref.hasError,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onKeyUp = _ref.onKeyUp,
    onKeyDown = _ref.onKeyDown,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_TextareaWrapper["default"], _extends({
    id: id,
    "aria-readonly": isReadOnly,
    "aria-disabled": isDisabled,
    ref: forwardedRef,
    name: name,
    resize: resize,
    placeholder: placeholder,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    value: value,
    rows: rows,
    cols: cols,
    minLength: minLength,
    maxLength: maxLength,
    disabled: isDisabled,
    readOnly: isReadOnly,
    hasError: hasError,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    onChange: onChange
  }, (0, _oxygenConfig.getTestAttributes)(testId), otherProps)));
};
exports.Textarea = Textarea;
Textarea.propTypes = {
  /**
   * Textarea theme
   */
  theme: _propTypes["default"].object.isRequired,
  /**
   * Component ref
   */
  forwardedRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  /**
   * The ID for textarea
   */
  id: _propTypes["default"].string,
  /**
   * The name for textarea
   */
  name: _propTypes["default"].string,
  /**
   * The content for textarea placeholder
   */
  placeholder: _propTypes["default"].string,
  /**
   * Define autocomplete attribute for Textarea
   */
  autoComplete: _propTypes["default"].string,
  /**
   * Define autofocus attribute for Textarea
   */
  autoFocus: _propTypes["default"].bool,
  /**
   * The textarea content value
   */
  value: _propTypes["default"].string,
  /**
   * Describe number of rows in textarea
   */
  rows: _propTypes["default"].number,
  /**
   * Describe number of columns in textarea
   */
  cols: _propTypes["default"].number,
  /**
   * The textarea minimum characters number
   */
  minLength: _propTypes["default"].number,
  /**
   * The textarea maximum characters number
   */
  maxLength: _propTypes["default"].number,
  /**
   * Type of resize textarea
   */
  resize: _propTypes["default"].oneOf(['auto', 'vertical', 'horizontal', 'both', 'none', 'block', 'inline']),
  /**
   * Id for automated tests
   */
  testId: _propTypes["default"].string,
  /**
   * Tell if the textarea is disabled
   */
  isDisabled: _propTypes["default"].bool,
  /**
   * Tell if the textarea is readonly
   */
  isReadOnly: _propTypes["default"].bool,
  /**
   * Tell if value of textarea is valid
   */
  hasError: _propTypes["default"].bool,
  /**
   * Handler to be called when the textarea is blurred
   */
  onBlur: _propTypes["default"].func,
  /**
   * Handler to be called when the textarea change
   */
  onChange: _propTypes["default"].func,
  /**
   * Handler to be called when the textarea is focused
   */
  onFocus: _propTypes["default"].func,
  /**
   * Handler to be called when the key up
   */
  onKeyUp: _propTypes["default"].func,
  /**
   * Handler to be called when the key down
   */
  onKeyDown: _propTypes["default"].func
};
Textarea.defaultProps = {
  id: undefined,
  forwardedRef: null,
  name: undefined,
  placeholder: undefined,
  autoComplete: 'off',
  autoFocus: false,
  value: undefined,
  isDisabled: false,
  isReadOnly: false,
  hasError: false,
  rows: 3,
  cols: undefined,
  minLength: undefined,
  maxLength: undefined,
  resize: 'vertical',
  testId: 'TEXTAREA',
  onBlur: _lodash["default"],
  onFocus: _lodash["default"],
  onChange: _lodash["default"],
  onKeyUp: _lodash["default"],
  onKeyDown: _lodash["default"]
};
var _default = (0, _oxygenConfig.withTheme)(Textarea, _themeName["default"]);
exports["default"] = _default;